import { Pipe, PipeTransform } from '@angular/core';
import { applyPrecision, isNumberFinite, isUndefined } from '../helpers/helpers';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'bits' })
export class BitsPipe implements PipeTransform {

  constructor(public translateService: TranslateService) { }

  private dictionary: Array<{ max: number; type: string }> = [
    { max: 1000, type: 'b' },
    { max: 1000000, type: 'kb' },
    { max: 1000000000, type: 'Mb' },
    { max: 1000000000000, type: 'Gb' },
    { max: 1000000000000000, type: 'Tb' },
    { max: Infinity, type: 'Tb' }, // TO FIX don't know what to set here
  ];

  transform(value: number, precision?: number | undefined): string | number {
    if (!isNumberFinite(value)) {
      return null;
    }

    const valueInBits = value * 8;
    const format = this.dictionary.find(d => valueInBits < d.max) || this.dictionary[this.dictionary.length - 1];
    const calc = (valueInBits / (format.max / 1000));
    const num = isUndefined(precision) ? calc : applyPrecision(calc, precision);

    return `${num} ${format.type}`;
  }
}
